export default function maskedCurrencyToNumber(masked: string) {
  if (!masked) return NaN;

  const normalized = masked.replace(/[^\d.,-]/g, '');

  if (!normalized) return NaN;

  return Number(normalized.replaceAll('.', '').replace(',', '.'));
}
